export const MapMixins = {
  data() {
    return {
      images: {
        //icon_pack 0
        0: [
          { url: '/markers/moving_vehicle_0.png', id: '0', icon_type: 0, vehicle_type: 0 },
          { url: '/markers/stoped_vehicle_0.png', id: '1', icon_type: 0, vehicle_type: 0 },
          { url: '/markers/idling_vehicle_0.png', id: '2', icon_type: 0, vehicle_type: 0 },
          { url: '/markers/passive_vehicle_0.png', id: '3', icon_type: 0, vehicle_type: 0 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 0, vehicle_type: 0 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 0, vehicle_type: 0 },

          { url: '/markers/moving_bus_0.png', id: '0', icon_type: 0, vehicle_type: 1 },
          { url: '/markers/stoped_bus_0.png', id: '1', icon_type: 0, vehicle_type: 1 },
          { url: '/markers/idling_bus_0.png', id: '2', icon_type: 0, vehicle_type: 1 },
          { url: '/markers/passive_bus_0.png', id: '3', icon_type: 0, vehicle_type: 1 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 0, vehicle_type: 1 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 0, vehicle_type: 1 },

          { url: '/markers/moving_truck_0.png', id: '0', icon_type: 0, vehicle_type: 2 },
          { url: '/markers/stoped_truck_0.png', id: '1', icon_type: 0, vehicle_type: 2 },
          { url: '/markers/idling_truck_0.png', id: '2', icon_type: 0, vehicle_type: 2 },
          { url: '/markers/passive_truck_0.png', id: '3', icon_type: 0, vehicle_type: 2 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 0, vehicle_type: 2 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 0, vehicle_type: 2 },

          { url: '/markers/moving_motorcycle_0.png', id: '0', icon_type: 0, vehicle_type: 4 },
          { url: '/markers/stoped_motorcycle_0.png', id: '1', icon_type: 0, vehicle_type: 4 },
          { url: '/markers/idling_motorcycle_0.png', id: '2', icon_type: 0, vehicle_type: 4 },
          { url: '/markers/passive_motorcycle_0.png', id: '3', icon_type: 0, vehicle_type: 4 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 0, vehicle_type: 4 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 0, vehicle_type: 4 },

          { url: '/markers/moving_boat_0.png', id: '0', icon_type: 0, vehicle_type: 5 },
          { url: '/markers/stoped_boat_0.png', id: '1', icon_type: 0, vehicle_type: 5 },
          { url: '/markers/idling_boat_0.png', id: '2', icon_type: 0, vehicle_type: 5 },
          { url: '/markers/passive_boat_0.png', id: '3', icon_type: 0, vehicle_type: 5 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 0, vehicle_type: 5 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 0, vehicle_type: 5 },

          { url: '/markers/moving_heavy_duty_0.png', id: '0', icon_type: 0, vehicle_type: 6 },
          { url: '/markers/stoped_heavy_duty_0.png', id: '1', icon_type: 0, vehicle_type: 6 },
          { url: '/markers/idling_heavy_duty_0.png', id: '2', icon_type: 0, vehicle_type: 6 },
          { url: '/markers/passive_heavy_duty_0.png', id: '3', icon_type: 0, vehicle_type: 6 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 0, vehicle_type: 6 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 0, vehicle_type: 6 },

          { url: '/markers/moving_pickup_0.png', id: '0', icon_type: 0, vehicle_type: 7 },
          { url: '/markers/stoped_pickup_0.png', id: '1', icon_type: 0, vehicle_type: 7 },
          { url: '/markers/idling_pickup_0.png', id: '2', icon_type: 0, vehicle_type: 7 },
          { url: '/markers/passive_pickup_0.png', id: '3', icon_type: 0, vehicle_type: 7 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 0, vehicle_type: 7 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 0, vehicle_type: 7 },

          { url: '/markers/moving_pickup_0.png', id: '0', icon_type: 0, vehicle_type: 8 },
          { url: '/markers/stoped_pickup_0.png', id: '1', icon_type: 0, vehicle_type: 8 },
          { url: '/markers/idling_pickup_0.png', id: '2', icon_type: 0, vehicle_type: 8 },
          { url: '/markers/passive_pickup_0.png', id: '3', icon_type: 0, vehicle_type: 8 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 0, vehicle_type: 8 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 0, vehicle_type: 8 },

          { url: '/markers/moving_truck_0.png', id: '0', icon_type: 0, vehicle_type: 9 },
          { url: '/markers/stoped_truck_0.png', id: '1', icon_type: 0, vehicle_type: 9 },
          { url: '/markers/idling_truck_0.png', id: '2', icon_type: 0, vehicle_type: 9 },
          { url: '/markers/passive_truck_0.png', id: '3', icon_type: 0, vehicle_type: 9 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 0, vehicle_type: 9 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 0, vehicle_type: 9 },
        ],
        //icon_pack 1
        1: [
          { url: '/markers/moving_vehicle_1.png', id: '0', icon_type: 1, vehicle_type: 0 },
          { url: '/markers/stoped_vehicle_1.png', id: '1', icon_type: 1, vehicle_type: 0 },
          { url: '/markers/idling_vehicle_1.png', id: '2', icon_type: 1, vehicle_type: 0 },
          { url: '/markers/passive_vehicle_1.png', id: '3', icon_type: 1, vehicle_type: 0 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 1, vehicle_type: 0 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 1, vehicle_type: 0 },

          { url: '/markers/moving_bus_0.png', id: '0', icon_type: 1, vehicle_type: 1 },
          { url: '/markers/stoped_bus_0.png', id: '1', icon_type: 1, vehicle_type: 1 },
          { url: '/markers/idling_bus_0.png', id: '2', icon_type: 1, vehicle_type: 1 },
          { url: '/markers/passive_bus_0.png', id: '3', icon_type: 1, vehicle_type: 1 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 1, vehicle_type: 1 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 1, vehicle_type: 1 },

          { url: '/markers/moving_truck_0.png', id: '0', icon_type: 1, vehicle_type: 2 },
          { url: '/markers/stoped_truck_0.png', id: '1', icon_type: 1, vehicle_type: 2 },
          { url: '/markers/idling_truck_0.png', id: '2', icon_type: 1, vehicle_type: 2 },
          { url: '/markers/passive_truck_0.png', id: '3', icon_type: 1, vehicle_type: 2 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 1, vehicle_type: 2 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 1, vehicle_type: 2 },

          { url: '/markers/moving_motorcycle_0.png', id: '0', icon_type: 1, vehicle_type: 4 },
          { url: '/markers/stoped_motorcycle_0.png', id: '1', icon_type: 1, vehicle_type: 4 },
          { url: '/markers/idling_motorcycle_0.png', id: '2', icon_type: 1, vehicle_type: 4 },
          { url: '/markers/passive_motorcycle_0.png', id: '3', icon_type: 1, vehicle_type: 4 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 1, vehicle_type: 4 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 1, vehicle_type: 4 },

          { url: '/markers/moving_boat_0.png', id: '0', icon_type: 1, vehicle_type: 5 },
          { url: '/markers/stoped_boat_0.png', id: '1', icon_type: 1, vehicle_type: 5 },
          { url: '/markers/idling_boat_0.png', id: '2', icon_type: 1, vehicle_type: 5 },
          { url: '/markers/passive_boat_0.png', id: '3', icon_type: 1, vehicle_type: 5 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 1, vehicle_type: 5 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 1, vehicle_type: 5 },

          { url: '/markers/moving_heavy_duty_0.png', id: '0', icon_type: 1, vehicle_type: 6 },
          { url: '/markers/stoped_heavy_duty_0.png', id: '1', icon_type: 1, vehicle_type: 6 },
          { url: '/markers/idling_heavy_duty_0.png', id: '2', icon_type: 1, vehicle_type: 6 },
          { url: '/markers/passive_heavy_duty_0.png', id: '3', icon_type: 1, vehicle_type: 6 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 1, vehicle_type: 6 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 1, vehicle_type: 6 },

          { url: '/markers/moving_pickup_0.png', id: '0', icon_type: 1, vehicle_type: 7 },
          { url: '/markers/stoped_pickup_0.png', id: '1', icon_type: 1, vehicle_type: 7 },
          { url: '/markers/idling_pickup_0.png', id: '2', icon_type: 1, vehicle_type: 7 },
          { url: '/markers/passive_pickup_0.png', id: '3', icon_type: 1, vehicle_type: 7 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 1, vehicle_type: 7 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 1, vehicle_type: 7 },

          { url: '/markers/moving_pickup_0.png', id: '0', icon_type: 1, vehicle_type: 8 },
          { url: '/markers/stoped_pickup_0.png', id: '1', icon_type: 1, vehicle_type: 8 },
          { url: '/markers/idling_pickup_0.png', id: '2', icon_type: 1, vehicle_type: 8 },
          { url: '/markers/passive_pickup_0.png', id: '3', icon_type: 1, vehicle_type: 8 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 1, vehicle_type: 8 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 1, vehicle_type: 8 },

          { url: '/markers/moving_truck_0.png', id: '0', icon_type: 1, vehicle_type: 9 },
          { url: '/markers/stoped_truck_0.png', id: '1', icon_type: 1, vehicle_type: 9 },
          { url: '/markers/idling_truck_0.png', id: '2', icon_type: 1, vehicle_type: 9 },
          { url: '/markers/passive_truck_0.png', id: '3', icon_type: 1, vehicle_type: 9 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 1, vehicle_type: 9 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 1, vehicle_type: 9 },
        ],
        //icon_pack 2
        2: [
          { url: '/markers/moving_vehicle_2.png', id: '0', icon_type: 2, vehicle_type: 0 },
          { url: '/markers/stoped_vehicle_2.png', id: '1', icon_type: 2, vehicle_type: 0 },
          { url: '/markers/idling_vehicle_2.png', id: '2', icon_type: 2, vehicle_type: 0 },
          { url: '/markers/passive_vehicle_2.png', id: '3', icon_type: 2, vehicle_type: 0 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 2, vehicle_type: 0 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 2, vehicle_type: 0 },

          { url: '/markers/moving_bus_0.png', id: '0', icon_type: 2, vehicle_type: 1 },
          { url: '/markers/stoped_bus_0.png', id: '1', icon_type: 2, vehicle_type: 1 },
          { url: '/markers/idling_bus_0.png', id: '2', icon_type: 2, vehicle_type: 1 },
          { url: '/markers/passive_bus_0.png', id: '3', icon_type: 2, vehicle_type: 1 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 2, vehicle_type: 1 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 2, vehicle_type: 1 },

          { url: '/markers/moving_truck_0.png', id: '0', icon_type: 2, vehicle_type: 2 },
          { url: '/markers/stoped_truck_0.png', id: '1', icon_type: 2, vehicle_type: 2 },
          { url: '/markers/idling_truck_0.png', id: '2', icon_type: 2, vehicle_type: 2 },
          { url: '/markers/passive_truck_0.png', id: '3', icon_type: 2, vehicle_type: 2 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 2, vehicle_type: 2 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 2, vehicle_type: 2 },

          { url: '/markers/moving_motorcycle_0.png', id: '0', icon_type: 2, vehicle_type: 4 },
          { url: '/markers/stoped_motorcycle_0.png', id: '1', icon_type: 2, vehicle_type: 4 },
          { url: '/markers/idling_motorcycle_0.png', id: '2', icon_type: 2, vehicle_type: 4 },
          { url: '/markers/passive_motorcycle_0.png', id: '3', icon_type: 2, vehicle_type: 4 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 2, vehicle_type: 4 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 2, vehicle_type: 4 },

          { url: '/markers/moving_boat_0.png', id: '0', icon_type: 2, vehicle_type: 5 },
          { url: '/markers/stoped_boat_0.png', id: '1', icon_type: 2, vehicle_type: 5 },
          { url: '/markers/idling_boat_0.png', id: '2', icon_type: 2, vehicle_type: 5 },
          { url: '/markers/passive_boat_0.png', id: '3', icon_type: 2, vehicle_type: 5 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 2, vehicle_type: 5 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 2, vehicle_type: 5 },

          { url: '/markers/moving_heavy_duty_0.png', id: '0', icon_type: 2, vehicle_type: 6 },
          { url: '/markers/stoped_heavy_duty_0.png', id: '1', icon_type: 2, vehicle_type: 6 },
          { url: '/markers/idling_heavy_duty_0.png', id: '2', icon_type: 2, vehicle_type: 6 },
          { url: '/markers/passive_heavy_duty_0.png', id: '3', icon_type: 2, vehicle_type: 6 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 2, vehicle_type: 6 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 2, vehicle_type: 6 },

          { url: '/markers/moving_pickup_0.png', id: '0', icon_type: 2, vehicle_type: 7 },
          { url: '/markers/stoped_pickup_0.png', id: '1', icon_type: 2, vehicle_type: 7 },
          { url: '/markers/idling_pickup_0.png', id: '2', icon_type: 2, vehicle_type: 7 },
          { url: '/markers/passive_pickup_0.png', id: '3', icon_type: 2, vehicle_type: 7 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 2, vehicle_type: 7 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 2, vehicle_type: 7 },

          { url: '/markers/moving_pickup_0.png', id: '0', icon_type: 2, vehicle_type: 8 },
          { url: '/markers/stoped_pickup_0.png', id: '1', icon_type: 2, vehicle_type: 8 },
          { url: '/markers/idling_pickup_0.png', id: '2', icon_type: 2, vehicle_type: 8 },
          { url: '/markers/passive_pickup_0.png', id: '3', icon_type: 2, vehicle_type: 8 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 2, vehicle_type: 8 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 2, vehicle_type: 8 },

          { url: '/markers/moving_truck_0.png', id: '0', icon_type: 2, vehicle_type: 9 },
          { url: '/markers/stoped_truck_0.png', id: '1', icon_type: 2, vehicle_type: 9 },
          { url: '/markers/idling_truck_0.png', id: '2', icon_type: 2, vehicle_type: 9 },
          { url: '/markers/passive_truck_0.png', id: '3', icon_type: 2, vehicle_type: 9 },
          { url: '/markers/no_signal_vehicle_0.png', id: '4', icon_type: 2, vehicle_type: 9 },
          { url: '/markers/demontage_vehicle_0.png', id: '100', icon_type: 2, vehicle_type: 9 },
        ],
      },
    };
  },
};
